// extracted by mini-css-extract-plugin
export default {"rotatingElementContainer":"RotatingElement_rotatingElementContainer__7ond8","svgContainer":"RotatingElement_svgContainer__L4wjl","svgStopped":"RotatingElement_svgStopped__SRn44"};